import BtnCustom from "components/common/btn-custom";
import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  Row,
} from "reactstrap";
import CustomInputField from "components/common/CustomInputField";
import handleError from "utils/handleError";
import { ErrorToaster } from "components/common/toast";
import { successToaster } from "components/common/toast";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { GetCicApi, DeleteCicApi, AddCicApi, UpdateCicApi } from "network/user";
import { ApiKeySchema } from "components/schema/ApiKeySchema";
import { UserContextProvider } from "context/UserContext";

const CicSettings = () => {
  const { t } = useTranslation("common");
  const [data, setData] = useState(null);
  const [alert, setAlert] = useState(null);
  const { fetchUser } = useContext(UserContextProvider);

  const getUserData = async () => {
    try {
      const response = await GetCicApi();
      if (response.success) {
        setData(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);
  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    isSubmitting,
    resetForm,
  } = useFormik({
    initialValues: {
      api_key: data?.api_key || "",
      sales_point_id: data?.sales_point_id || "",
    },
    enableReinitialize: true,
    validationSchema: ApiKeySchema,

    onSubmit: async (values) => {
      try {
        if (data?.api_key) {
          const response = await UpdateCicApi(values);
          if (response.success) {
            fetchUser();
            successToaster(t("cic.updated"));
          }
        } else {
          const response = await AddCicApi(values);
          if (response.success) {
            fetchUser();

            successToaster(t("cic.added"));
            getUserData();
          }
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
      } finally {
      }
    },
  });
  const warningWithConfirmMessage = () => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("cic.confirmTitle")}
        onConfirm={() => successDelete()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("cic.confirmDelete")}
        cancelBtnText={t("cic.cancel")}
        showCancel
        btnSize=""
      >
        {t("cic.confirmText")}
      </ReactBSAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };
  const successDelete = async () => {
    try {
      const response = await DeleteCicApi();
      if (response.success) {
        fetchUser();
        successToaster(t("cic.deleted"));
        setData(null);
        resetForm();
        hideAlert();
      } else {
        hideAlert();
        ErrorToaster(t("cic.deleteFailed"));
      }
    } catch (error) {
      hideAlert();
      ErrorToaster(t("cic.deleteFailed"));
    }
  };
  return (
    <Card>
      {alert}
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="title">{t("cic.title")}</h5>
        <Button
          className="text-capitalize"
          color="danger"
          disabled={!data?.api_key}
          onClick={() => warningWithConfirmMessage()}
        >
          {t("cic.deleteKey")}
        </Button>
      </CardHeader>
      <Form onSubmit={handleSubmit}>
        <CardBody>
          <Row>
            <Col className="pr-md-1" md="6">
              <CustomInputField
                label={t("cic.apiLabel")}
                name="api_key"
                placeholder={t("cic.apiPlaceholder")}
                type="text"
                errors={errors}
                touched={touched}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values}
                className=""
              />
            </Col>
            <Col className="pr-md-1" md="6">
              <CustomInputField
                label={t("cic.salesPointLabel")}
                name="sales_point_id"
                placeholder={t("cic.salesPointPlaceholder")}
                type="text"
                errors={errors}
                touched={touched}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values}
              />
            </Col>
          </Row>
        </CardBody>

        <CardFooter>
          <BtnCustom
            className="btn-fill"
            color="primary"
            type="submit"
            submittingText={t("cic.saving")}
            isLoading={isSubmitting}
          >
            {t("cic.save")}
          </BtnCustom>
        </CardFooter>
      </Form>
    </Card>
  );
};

export default CicSettings;
